module.exports = __webpack_public_path__ + "img/二级页面海报4G室外机.7b229986.jpg";